import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/terms/components/TermsContent.tsx");
